export const LOCAL_AWS_DEFAULT_DASHBOARD = 'AWS Default';
export const LOCAL_AZURE_DEFAULT_DASHBOARD = 'Azure Default';
export const LOCAL_GCP_DEFAULT_DASHBOARD = 'GCP Default';
export const LOCAL_OCI_DEFAULT_DASHBOARD = 'OCI Default';
export const LOCAL_KUBERNETES_DEFAULT_DASHBOARD = 'Kubernetes Default';
export const LOCAL_SERVERLESS_DEFAULT_DASHBOARD = 'Serverless Default';
